import { MyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { AssortmentExportColumn } from './AssortmentExportColumn';

export const columnHeaders = (
  t: MyAssortmentTFunction
): Record<AssortmentExportColumn, string> => ({
  supplierItemPrimaryText: t('myAssortment.columns.itemText'),
  mgItemNumber: t('myAssortment.productCard.mgItemNr'),
  finfoNumber: t('myAssortment.columns.finfoNumber'),
  nobbNumber: t('myAssortment.columns.nobbNumber'),
  primaryGtin: t('myAssortment.columns.primaryUnitGtin'),
  supplierName: t('myAssortment.columns.supplier'),
  productGroupNumber: t('myAssortment.columns.itemGroup'),
  discountGroupName: t('myAssortment.columns.discountGroup'),
  purchaseConditionName: t('myAssortment.columns.purchaseCondition.name'),
  purchaseConditionLevel: t('myAssortment.columns.purchaseCondition.level'),
  purchasePrice: t('myAssortment.columns.purchasePrice.price'),
  purchasePriceUnit: t('myAssortment.columns.purchasePrice.unit'),
  purchasePriceDate: t('myAssortment.columns.purchasePrice.date'),
  futurePurchasePrice: t('myAssortment.columns.futurePurchasePrice.price'),
  futurePurchasePriceUnit: t('myAssortment.columns.futurePurchasePrice.unit'),
  futurePurchasePriceDate: t('myAssortment.columns.futurePurchasePrice.date'),
  purchasePriceChangeAbsolute: t('myAssortment.columns.purchasePrice.change.absolute'),
  purchasePriceChangePercentage: t('myAssortment.columns.purchasePrice.change.percentage'),
  freightValue: t('myAssortment.columns.freightCondition.value'),
  freightValueDenomination: t('myAssortment.columns.freightCondition.denomination'),
  freightUnit: t('myAssortment.columns.freightCondition.unit'),
  costPrice: t('myAssortment.columns.costPrice.price'),
  costPriceUnit: t('myAssortment.columns.costPrice.unit'),
  costPriceDate: t('myAssortment.columns.costPrice.date'),
  costPriceInBasePriceUnit: t('myAssortment.columns.costPrice.priceBPU'),
  costPriceBasePriceUnit: t('myAssortment.columns.costPrice.unitBPU'),
  MGLSalesPrice: t('myAssortment.columns.MGLPrice'),
  MGLDG: t('myAssortment.columns.salesCoverageMGL'),
  customerFactor: t('myAssortment.columns.customerMarkup'),
  salesPriceExVat: t('myAssortment.columns.salesPriceExVat'),
  salesPriceIncVat: t('myAssortment.columns.salesPriceIncVat'),
  salesPriceUnit: t('myAssortment.columns.salesPriceUnit'),
  salesPriceDate: t('myAssortment.columns.salesPriceDate'),
  salesPriceCoverage: t('myAssortment.salesCoverage'),
  vatRate: t('myAssortment.columns.vatRate'),
  futureSalesPriceExVat: t('myAssortment.columns.futureSalesPriceExVat'),
  futureSalesPriceIncVat: t('myAssortment.columns.futureSalesPriceIncVat'),
  futureSalesPriceUnit: t('myAssortment.columns.futureSalesPriceUnit'),
  futureSalesPriceDate: t('myAssortment.columns.futureSalesPriceDate'),
  futureSalesPriceCoverage: t('myAssortment.columns.futureSalesPriceCoverage'),
  salesPriceExVatChangeAbsolute: t('myAssortment.columns.salesPriceExVatChangeAbsolute'),
  salesPriceIncVatChangeAbsolute: t('myAssortment.columns.salesPriceIncVatChangeAbsolute'),
  salesPriceChangePercantage: t('myAssortment.columns.salesPriceChangePercentage'),
  salesPriceDpakExVat: t('myAssortment.columns.salesPriceDpakExVat'),
  salesPriceDpakIncVat: t('myAssortment.columns.salesPriceDpakIncVat'),
  salesPriceDpakCoverage: t('myAssortment.columns.salesCoverageDpak'),
  salesPriceTpakExVat: t('myAssortment.columns.salesPriceTpakExVat'),
  salesPriceTpakIncVat: t('myAssortment.columns.salesPriceTpakIncVat'),
  salesPriceTpakCoverage: t('myAssortment.columns.salesCoverageTpak'),
  priceConditionOrigin: t('myAssortment.columns.priceCondition.origin'),
  priceSuggestionType: t('myAssortment.columns.priceCondition.priceSuggestionType'),
  priceConditionLevel: t('myAssortment.columns.priceCondition.level'),
  assortmentDate: t('myAssortment.columns.addedToAssortmentDate'),
  expiresFromAssortmentDate: t('myAssortment.columns.expiresFromAssortmentDate'),
  assortmentSource: t('myAssortment.columns.source'),
  finfoExpiresDate: t('myAssortment.columns.finfoExpiration.date'),
  finfoExpiresStatus: t('myAssortment.columns.discontinuation'),
  addedBy: t('myAssortment.columns.addedBy'),
});
